import type { Enterprise, ProductItem, ProcessingBatch, QualityRecord } from '@trace/shared/types';

export const mockEnterprises: Enterprise[] = [
  {
    id: '8001',
    name: '五常市金穗生态大米加工有限公司',
    brandName: '北米臻选 · 有机胚芽米',
    code: 'ENT-WS-001',
    logo: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=120&auto=format&fit=crop&q=80',
    contactPerson: '孙海峰',
    contactPhone: '13700137001',
    status: 'active', // 有效
    enterpriseCode: 'MA.156.A1.0058',
    allocatedQuota: 200000,
    usedQuota: 48600,
    licenseNumber: 'SC10123018401234',
    creditCode: '91230184MA1B2C3D4E',
    address: '黑龙江省哈尔滨市五常市经济开发区粮油工业园A区8号',
    remarks: '五常市农业产业化重点龙头企业，具备10万级洁净GMP标准智能加工车间',
    createdAt: '2026-01-01T00:00:00Z',
    updatedAt: '2026-08-20T00:00:00Z',
  },
  {
    id: '8002',
    name: '齐齐哈尔嫩江绿色农业加工厂',
    brandName: '禾本真 · 嫩江富硒生态胚芽米',
    code: 'ENT-NJ-002',
    logo: 'https://images.unsplash.com/photo-1543083477-4f785aeafaa9?w=120&auto=format&fit=crop&q=80',
    contactPerson: '陈建华',
    contactPhone: '13700137002',
    status: 'active', // 有效
    enterpriseCode: 'MA.156.A1.0059',
    allocatedQuota: 100000,
    usedQuota: 12500,
    licenseNumber: 'SC10123022405678',
    creditCode: '91230224MA2C3D4E5F',
    address: '黑龙江省齐齐哈尔市泰来县绿色食品产业园3栋',
    remarks: '富硒功能大米专属加工基地，配备多级轻度柔碾留胚生产线',
    createdAt: '2026-02-15T00:00:00Z',
    updatedAt: '2026-08-15T00:00:00Z',
  },
  {
    id: '8003',
    name: '秋田满满（杭州）电子商务有限公司',
    brandName: '秋田满满 · 婴童有机胚芽米',
    code: 'ENT-QT-003',
    logo: 'https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=120&auto=format&fit=crop&q=80',
    contactPerson: '李经理',
    contactPhone: '13800138000',
    status: 'active',
    enterpriseCode: 'MA.156.A1.0068',
    allocatedQuota: 300000,
    usedQuota: 85000,
    licenseNumber: 'SC10133010809876',
    creditCode: '91330108MA2GYQW89C',
    address: '浙江省杭州市滨江区长河街道秋田满满大厦 (五常专属代工产线)',
    remarks: '专注于婴童辅食高标准营养胚芽米代工，充氮保鲜工艺',
    createdAt: '2026-03-01T00:00:00Z',
    updatedAt: '2026-08-30T00:00:00Z',
  },
  {
    id: '8004',
    name: '英氏（Engnice）营养食品科技有限公司',
    brandName: '英氏 · 辅食胚芽米',
    code: 'ENT-EN-004',
    logo: 'https://images.unsplash.com/photo-1544717305-2782549b5136?w=120&auto=format&fit=crop&q=80',
    contactPerson: '陈总监',
    contactPhone: '13900139000',
    status: 'active',
    enterpriseCode: 'MA.156.A1.0079',
    allocatedQuota: 250000,
    usedQuota: 62000,
    licenseNumber: 'SC10143010001122',
    creditCode: '91430100MA4L5M6N7P',
    address: '湖南省长沙市高新技术开发区英氏产业园',
    remarks: '全国高端母婴有机分阶辅食米代工伙伴',
    createdAt: '2026-03-15T00:00:00Z',
    updatedAt: '2026-08-28T00:00:00Z',
  },
];

export const mockBrands = mockEnterprises;

export const mockProducts: ProductItem[] = [
  {
    id: 'prod_01',
    name: '5kg 有机胚芽米六角真空礼盒装',
    code: 'PROD-ORG-5KG-GIFT',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productCode: 'AG.101',
    weight: 5,
    unit: 'kg',
    germRetentionRate: 85,
    packageType: '双层食品级铝箔真空袋 + 高档六角礼盒装',
    shelfLifeDays: 365,
    organicMark: 'ORG',
    status: 'active',
    standard: 'GB/T 19630 / GB/T 1354',
    remarks: '五常核心稻花香2号有机原粮精制，留胚率≥85%',
    createdAt: '2026-01-05T00:00:00Z',
    updatedAt: '2026-08-20T00:00:00Z',
  },
  {
    id: 'prod_02',
    name: '2.5kg 家庭锁鲜装 (双砖真空)',
    code: 'PROD-ORG-2.5KG-FAM',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productCode: 'AG.102',
    weight: 2.5,
    unit: 'kg',
    germRetentionRate: 82,
    packageType: '食品级PE真空砖型包装 (1.25kg*2砖)',
    shelfLifeDays: 365,
    organicMark: 'ORG',
    status: 'active',
    standard: 'GB/T 19630 / GB/T 1354',
    remarks: '家庭日常高频消费爆款，开砖保鲜',
    createdAt: '2026-01-10T00:00:00Z',
    updatedAt: '2026-08-20T00:00:00Z',
  },
  {
    id: 'prod_03',
    name: '1kg 宝宝辅食尝鲜装 (充氮小袋)',
    code: 'PROD-ORG-1KG-BABY',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productCode: 'AG.103',
    weight: 1,
    unit: 'kg',
    germRetentionRate: 88,
    packageType: '充氮独立便携小袋装 (100g*10袋)',
    shelfLifeDays: 365,
    organicMark: 'ORG',
    status: 'active',
    standard: 'GB/T 19630 / GB 10769',
    remarks: '婴幼儿辅食级标准，胚芽完整度高',
    createdAt: '2026-02-01T00:00:00Z',
    updatedAt: '2026-08-20T00:00:00Z',
  },
  {
    id: 'prod_04',
    name: '5kg 富硒生态胚芽米牛皮纸复合袋装',
    code: 'PROD-SE-5KG-BAG',
    enterpriseId: 'ent_02',
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    enterpriseCode: 'MA.156.A1.0059',
    productCode: 'SE.201',
    weight: 5,
    unit: 'kg',
    germRetentionRate: 80,
    packageType: '食品级铝箔内胆 + 牛皮纸复合外袋',
    shelfLifeDays: 365,
    organicMark: 'GRN',
    status: 'active',
    standard: 'NY/T 600 / GB/T 1354',
    remarks: '天然富硒嫩江基地原粮，有机硒含量实测达标',
    createdAt: '2026-02-20T00:00:00Z',
    updatedAt: '2026-08-15T00:00:00Z',
  },
  {
    id: 'prod_05',
    name: '10kg 餐饮商用锁鲜大袋装 (已停产)',
    code: 'PROD-ORG-10KG-COM',
    enterpriseId: 'ent_01',
    enterpriseName: '五常市金穗生态大米加工有限公司',
    enterpriseCode: 'MA.156.A1.0058',
    productCode: 'AG.199',
    weight: 10,
    unit: 'kg',
    germRetentionRate: 75,
    packageType: '高强度编织复合袋内衬防潮膜',
    shelfLifeDays: 180,
    organicMark: 'ORG',
    status: 'inactive',
    standard: 'GB/T 1354',
    remarks: '一期商用规格已停产，转为礼盒定制款',
    createdAt: '2026-01-15T00:00:00Z',
    updatedAt: '2026-07-01T00:00:00Z',
  },
];

export const mockOrders: any[] = [
  {
    id: 16001,
    orderNumber: 'ORD-20260826-008',
    customerName: '盒马鲜生 · 华北区域五常有机胚芽米中秋定制单',
    enterpriseId: 8001,
    enterpriseName: '五常市金穗生态大米加工有限公司',
    productId: 'prod_01',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    orderQuantity: 2000,
    itemsPerBox: 1,
    deliveryDate: '2026-09-05',
    contactPerson: '王经理 (生鲜采购部)',
    contactPhone: '13911002233',
    status: 'completed',
    syncSource: 'erp_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-20T08:00:00Z',
    updatedAt: '2026-08-26T18:00:00Z',
  },
  {
    id: 16002,
    orderNumber: 'ORD-20260825-005',
    customerName: '北京华联精品生活超市 · 双砖家庭装直供订单',
    enterpriseId: 8001,
    enterpriseName: '五常市金穗生态大米加工有限公司',
    productId: 'prod_02',
    productName: '2.5kg 家庭锁鲜装 (双砖真空)',
    orderQuantity: 1500,
    itemsPerBox: 2,
    deliveryDate: '2026-09-01',
    contactPerson: '张总监',
    contactPhone: '13811223344',
    status: 'completed',
    syncSource: 'erp_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-18T09:00:00Z',
    updatedAt: '2026-08-25T16:00:00Z',
  },
  {
    id: 16003,
    orderNumber: 'ORD-20260824-002',
    customerName: '东方甄选 · 嫩江天然富硒生态胚芽米专场定制单',
    enterpriseId: 8002,
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    productId: 'prod_03',
    productName: '嫩江富硒天然有机黑米 2.5kg',
    orderQuantity: 1800,
    itemsPerBox: 1,
    deliveryDate: '2026-08-30',
    contactPerson: '李经理 (选品中心)',
    contactPhone: '13700112233',
    status: 'completed',
    syncSource: 'erp_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-15T10:00:00Z',
    updatedAt: '2026-08-24T17:00:00Z',
  },
  {
    id: 16004,
    orderNumber: 'ORD-20260830-012',
    customerName: '秋田满满 · 华东母婴渠道2026新米专场定制单',
    enterpriseId: 8003,
    enterpriseName: '秋田满满（杭州）电子商务有限公司',
    productId: 'prod_04',
    productName: '秋田满满 · 婴幼儿有机胚芽稻花香米 300g',
    orderQuantity: 3000,
    itemsPerBox: 6,
    deliveryDate: '2026-09-10',
    contactPerson: '李经理 (供应链部)',
    contactPhone: '13800138000',
    status: 'in_production',
    syncSource: 'erp_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-22T08:00:00Z',
    updatedAt: '2026-08-30T19:00:00Z',
  },
  {
    id: 16005,
    orderNumber: 'ORD-20260829-009',
    customerName: '英式Engnice · 全国高端母婴连锁首批有机米定制单',
    enterpriseId: 8004,
    enterpriseName: '英氏（Engnice）营养食品科技有限公司',
    productId: 'prod_05',
    productName: '英式 · 婴幼儿有机低敏胚芽米 250g',
    orderQuantity: 2500,
    itemsPerBox: 4,
    deliveryDate: '2026-09-08',
    contactPerson: '陈总监 (质控中心)',
    contactPhone: '13900139000',
    status: 'in_production',
    syncSource: 'erp_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-25T09:30:00Z',
    updatedAt: '2026-08-29T18:00:00Z',
  },
];

export const mockMesProductionTasks: any[] = [
  {
    id: 10001,
    taskCode: 'MES-PROD-20260820-001',
    taskName: '五常1号田有机稻花香原粮初加工与脱壳清选工单',
    harvestBatchNo: 'PADDY-20260820-001',
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    riceVariety: '五优稻4号 (稻花香2号)',
    rawGrainWeightKg: 30000.0,
    outputWeightKg: 19800.0,
    millingRate: '66.0%',
    germRetention: '88.5%',
    hullingPressure: '0.35 MPa',
    moistureRate: '14.0%',
    workshopName: '五常核心示范区 · 1号原粮脱壳清选车间',
    lineName: '低温风冷脱壳色选1号线',
    priority: 'high',
    planStartTime: '2026-08-20 08:00:00',
    planEndTime: '2026-08-21 18:00:00',
    actualStartTime: '2026-08-20 08:15:00',
    actualEndTime: '2026-08-21 17:30:00',
    status: 'completed',
    qcResult: 'excellent',
    qcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    qcReportName: '五常1号田原粮进厂508项农残全项质检报告.pdf',
    qcReportSize: 3840000,
    qcInspector: '张建华',
    qcTime: '2026-08-21 18:00:00',
    germQcResult: 'excellent',
    germQcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    germQcReportName: '五常1号田初碾稻花香胚芽米留胚率与纯度全项质检单.pdf',
    germQcReportSize: 3120000,
    germQcInspector: '张建华',
    germQcTime: '2026-08-21 18:30:00',
    remarks: '原粮饱满无杂质，水分14.0%，初碾出成率达66.0%，特级原粮',
    syncSource: 'mes_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-20T08:00:00Z',
    updatedAt: '2026-08-21T18:00:00Z',
  },
  {
    id: 10002,
    taskCode: 'MES-PROD-20260822-002',
    taskName: '2号田龙稻18原粮初清理与分级筛理工单',
    harvestBatchNo: 'PADDY-20260822-002',
    landId: 'land_02',
    landName: '五常核心有机基地 · 2号稻田B区',
    riceVariety: '龙稻18 (优质长粒香)',
    rawGrainWeightKg: 25000.0,
    outputWeightKg: 16500.0,
    millingRate: '66.0%',
    germRetention: '86.5%',
    hullingPressure: '0.32 MPa',
    moistureRate: '14.1%',
    workshopName: '五常核心示范区 · 1号原粮脱壳清选车间',
    lineName: '低温风冷脱壳色选2号线',
    priority: 'medium',
    planStartTime: '2026-08-22 08:30:00',
    planEndTime: '2026-08-23 16:00:00',
    actualStartTime: '2026-08-22 08:40:00',
    actualEndTime: '2026-08-23 15:40:00',
    status: 'completed',
    qcResult: 'pass',
    qcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    qcReportName: '2号田龙稻18进厂水分与纯度质检合格单.pdf',
    qcReportSize: 2560000,
    qcInspector: '李宏',
    qcTime: '2026-08-23 16:00:00',
    germQcResult: 'pass',
    germQcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    germQcReportName: '2号田龙稻18胚芽米碎米率与加工精度检验报告.pdf',
    germQcReportSize: 2240000,
    germQcInspector: '李宏',
    germQcTime: '2026-08-23 16:20:00',
    remarks: '水分14.1%，谷外糙米率低于0.5%，色选合格',
    syncSource: 'mes_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-22T08:30:00Z',
    updatedAt: '2026-08-23T16:00:00Z',
  },
  {
    id: 10003,
    taskCode: 'MES-PROD-20260825-003',
    taskName: '嫩江富硒黑米原粮深色选与风选除杂工单',
    harvestBatchNo: 'PADDY-20260825-003',
    landId: 'land_03',
    landName: '嫩江高寒富硒基地 · 黑珍珠1号田',
    riceVariety: '嫩江富硒黑珍珠有机稻',
    rawGrainWeightKg: 20000.0,
    outputWeightKg: 13200.0,
    millingRate: '66.0%',
    germRetention: '91.2%',
    hullingPressure: '0.28 MPa',
    moistureRate: '13.9%',
    workshopName: '嫩江现代农业示范园 · 原粮处理车间',
    lineName: '多光谱智能黑米色选专线',
    priority: 'high',
    planStartTime: '2026-08-25 09:00:00',
    planEndTime: '2026-08-26 17:00:00',
    actualStartTime: '2026-08-25 09:10:00',
    actualEndTime: '2026-08-26 16:50:00',
    status: 'completed',
    qcResult: 'excellent',
    qcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    qcReportName: '嫩江高寒富硒黑米原粮硒含量与有机理化检验报告.pdf',
    qcReportSize: 4120000,
    qcInspector: '张建华',
    qcTime: '2026-08-26 17:00:00',
    remarks: '有机硒含量 0.28mg/kg，花青素含量优异',
    syncSource: 'mes_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-25T09:00:00Z',
    updatedAt: '2026-08-26T17:00:00Z',
  },
];

export const mockMesProcessingTasks: any[] = [
  {
    id: 10101,
    taskCode: 'MES-PROC-20260825-001',
    taskName: '北米金胚 5kg 真空六角礼盒装全自动分装与包装工单',
    orderId: 16001,
    orderNumber: 'ORD-20260826-008',
    productionTaskId: 10001,
    productionTaskCode: 'MES-PROD-20260820-001',
    materialItems: [
      {
        id: 'mat_01',
        processingTaskId: 10101,
        productionTaskId: 10001,
        productionTaskCode: 'MES-PROD-20260820-001',
        harvestBatchNo: 'PADDY-20260820-001',
        riceVariety: '五优稻4号 (稻花香2号)',
        landName: '五常核心有机基地 · 1号稻田A区',
        usedGrainWeightKg: 8000,
      },
      {
        id: 'mat_02',
        processingTaskId: 10101,
        productionTaskId: 10002,
        productionTaskCode: 'MES-PROD-20260822-002',
        harvestBatchNo: 'PADDY-20260822-002',
        riceVariety: '龙稻18 (优质长粒香)',
        landName: '五常核心有机基地 · 2号稻田B区',
        usedGrainWeightKg: 2000,
      },
    ],
    productId: 'prod_01',
    productName: '5kg 有机胚芽米六角真空礼盒装',
    enterpriseId: 8001,
    enterpriseName: '五常市金穗生态大米加工有限公司',
    packageSpec: '5kg (双砖真空锁鲜)',
    planQuantity: 2000,
    finishedQuantity: 2000,
    unit: '盒',
    workshopName: '五常核心示范区 · 低温锁鲜分装车间',
    lineName: '全自动充氮真空双砖包装1号线',
    operator: '李春山',
    planStartTime: '2026-08-25 08:00:00',
    planEndTime: '2026-08-25 18:00:00',
    actualStartTime: '2026-08-25 08:10:00',
    actualEndTime: '2026-08-25 17:50:00',
    status: 'completed',
    qcResult: 'excellent',
    qcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    qcReportName: '北米金胚有机胚芽米SGS出厂508项全项质检报告.pdf',
    qcReportSize: 5120000,
    qcInspector: '张建华',
    qcTime: '2026-08-25 18:00:00',
    remarks: '真空度达标，外观无漏气，合格出厂',
    syncSource: 'mes_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-25T08:00:00Z',
    updatedAt: '2026-08-25T18:00:00Z',
  },
  {
    id: 10102,
    taskCode: 'MES-PROC-20260826-002',
    taskName: '嫩江天然富硒黑米 2.5kg 礼盒装真空分装工单',
    orderId: 16003,
    orderNumber: 'ORD-20260824-002',
    productionTaskId: 10003,
    productionTaskCode: 'MES-PROD-20260825-003',
    materialItems: [
      {
        id: 'mat_03',
        processingTaskId: 10102,
        productionTaskId: 10003,
        productionTaskCode: 'MES-PROD-20260825-003',
        harvestBatchNo: 'PADDY-20260825-003',
        riceVariety: '嫩江富硒生态有机黑米',
        landName: '齐齐哈尔嫩江绿色农业示范基地 · 3号黑土区',
        usedGrainWeightKg: 4500,
      },
    ],
    productId: 'prod_03',
    productName: '嫩江富硒天然有机黑米 2.5kg',
    enterpriseId: 8002,
    enterpriseName: '齐齐哈尔嫩江绿色农业加工厂',
    packageSpec: '2.5kg 礼盒装',
    planQuantity: 1800,
    finishedQuantity: 1800,
    unit: '盒',
    workshopName: '嫩江现代农业示范园 · 高端真空包装车间',
    lineName: '全自动双通道色选与真空锁鲜装填线',
    operator: '王建国',
    planStartTime: '2026-08-26 08:30:00',
    planEndTime: '2026-08-26 17:30:00',
    actualStartTime: '2026-08-26 08:35:00',
    actualEndTime: '2026-08-26 17:15:00',
    status: 'completed',
    qcResult: 'pass',
    qcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    qcReportName: '嫩江富硒黑米出厂品质全项检验报告(GB-T19630).pdf',
    qcReportSize: 3680000,
    qcInspector: '李宏',
    qcTime: '2026-08-26 17:30:00',
    remarks: '天然富硒黑米真空封装完好，装填无误',
    syncSource: 'mes_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-26T08:30:00Z',
    updatedAt: '2026-08-26T17:30:00Z',
  },
  {
    id: 10103,
    taskCode: 'MES-PROC-20260829-003',
    taskName: '秋田满满 300g 婴幼儿有机胚芽稻花香充氮易撕听装代工工单',
    orderId: 16004,
    orderNumber: 'ORD-20260830-012',
    productionTaskId: 10001,
    productionTaskCode: 'MES-PROD-20260820-001',
    materialItems: [
      {
        id: 'mat_04',
        processingTaskId: 10103,
        productionTaskId: 10001,
        productionTaskCode: 'MES-PROD-20260820-001',
        harvestBatchNo: 'PADDY-20260820-001',
        riceVariety: '五优稻4号 (稻花香2号)',
        landName: '五常核心有机基地 · 1号稻田A区',
        usedGrainWeightKg: 900,
      },
    ],
    productId: 'prod_04',
    productName: '秋田满满 · 婴幼儿有机胚芽稻花香米 300g',
    enterpriseId: 8003,
    enterpriseName: '秋田满满（杭州）电子商务有限公司',
    packageSpec: '300g (六角高阻隔易撕听装 / 6罐提装)',
    planQuantity: 3000,
    finishedQuantity: 3000,
    unit: '盒',
    workshopName: '五常核心示范区 · 低温母婴代工专线',
    lineName: '十万级洁净母婴充氮锁鲜听装流水线',
    operator: '李春山',
    planStartTime: '2026-08-29 08:00:00',
    planEndTime: '2026-08-29 19:00:00',
    actualStartTime: '2026-08-29 08:15:00',
    actualEndTime: '2026-08-29 18:45:00',
    status: 'completed',
    qcResult: 'excellent',
    qcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    qcReportName: '秋田满满母婴辅食级有机米出厂重金属与微生物质检单.pdf',
    qcReportSize: 4650000,
    qcInspector: '张建华',
    qcTime: '2026-08-29 19:00:00',
    remarks: '充氮锁鲜，无菌装罐，残氧量低于0.3%',
    syncSource: 'mes_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-29T08:00:00Z',
    updatedAt: '2026-08-29T19:00:00Z',
  },
  {
    id: 10104,
    taskCode: 'MES-PROC-20260830-004',
    taskName: '英式 250g 婴幼儿有机低敏胚芽米充氮分装工单',
    orderId: 16005,
    orderNumber: 'ORD-20260829-009',
    productionTaskId: 10002,
    productionTaskCode: 'MES-PROD-20260822-002',
    productId: 'prod_05',
    productName: '英式 · 婴幼儿有机低敏胚芽米 250g',
    enterpriseId: 8004,
    enterpriseName: '英氏（Engnice）营养食品科技有限公司',
    packageSpec: '250g (充氮铝箔锁鲜分装 / 4袋礼盒)',
    planQuantity: 2500,
    finishedQuantity: 2500,
    unit: '盒',
    workshopName: '五常核心示范区 · 高洁净无尘充氮包装车间',
    lineName: '全自动化充氮密封包装线',
    operator: '李宏',
    planStartTime: '2026-08-30 08:30:00',
    planEndTime: '2026-08-30 18:30:00',
    actualStartTime: '2026-08-30 08:40:00',
    actualEndTime: '2026-08-30 18:10:00',
    status: 'completed',
    qcResult: 'excellent',
    qcReportUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200',
    qcReportName: '英式有机低敏胚芽米出厂全项品质检验合格书.pdf',
    qcReportSize: 3980000,
    qcInspector: '张建华',
    qcTime: '2026-08-30 18:30:00',
    remarks: '无化学添加，密封性优异，合格出厂',
    syncSource: 'mes_sync',
    syncTime: '2026-09-01T10:00:00Z',
    createdAt: '2026-08-30T08:30:00Z',
    updatedAt: '2026-08-30T18:30:00Z',
  },
];

export const mockQualityRecords: Record<string, QualityRecord> = {
  'batch_01': {
    id: 'qr_01',
    batchId: 'batch_01',
    reportNumber: 'CTI-20260822-R089',
    inspector: '王丽娟 (国家注册农产品质检工程师)',
    inspectionDate: '2026-08-22T14:30:00Z',
    germRetentionRate: 86.4,
    brokenRiceRate: 3.2,
    moistureRate: 14.1,
    heavyMetalLead: 0.02,
    heavyMetalCadmium: 0.01,
    pesticideResiduePassed: true,
    passed: true,
    reportFileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&auto=format&fit=crop&q=80',
    createdAt: '2026-08-22T15:00:00Z',
    updatedAt: '2026-08-22T15:00:00Z',
  },
  'batch_02': {
    id: 'qr_02',
    batchId: 'batch_02',
    reportNumber: 'CTI-20260825-R093',
    inspector: '王丽娟 (国家注册农产品质检工程师)',
    inspectionDate: '2026-08-25T11:20:00Z',
    germRetentionRate: 83.2,
    brokenRiceRate: 2.8,
    moistureRate: 13.8,
    heavyMetalLead: 0.01,
    heavyMetalCadmium: 0.01,
    pesticideResiduePassed: true,
    passed: true,
    reportFileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&auto=format&fit=crop&q=80',
    createdAt: '2026-08-25T11:30:00Z',
    updatedAt: '2026-08-25T11:30:00Z',
  },
  'batch_03': {
    id: 'qr_03',
    batchId: 'batch_03',
    reportNumber: 'HLJ-20260826-S102',
    inspector: '刘德胜 (高级农产品质检员)',
    inspectionDate: '2026-08-26T10:00:00Z',
    germRetentionRate: 81.5,
    brokenRiceRate: 3.5,
    moistureRate: 14.0,
    heavyMetalLead: 0.01,
    heavyMetalCadmium: 0.01,
    pesticideResiduePassed: true,
    passed: true,
    reportFileUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&auto=format&fit=crop&q=80',
    createdAt: '2026-08-26T10:30:00Z',
    updatedAt: '2026-08-26T10:30:00Z',
  },
};

export const mockProcessingBatches: ProcessingBatch[] = [
  {
    id: 'batch_01',
    batchNumber: 'PROC-20260822-001',
    brandId: 'ent_01',
    brandName: '北米臻选 · 有机胚芽米',
    productSpecId: 'prod_01',
    productSpecName: '5kg 有机胚芽米六角真空礼盒装',
    rawPaddyBatchNumber: 'PADDY-20260820-001',
    rawPaddyWeight: 20000,
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    harvestYear: 2026,
    outputWeight: 13200,
    yieldRate: 66.0,
    processingDate: '2026-08-22T08:00:00Z',
    workshopName: '五常金穗 10万级GMP标准智能加工车间 #02产线',
    manager: '孙海峰 (加工车间主管)',
    status: 'completed',
    craftParameters: [
      { id: 'c_01', name: '佐竹胶辊砻谷脱壳率', targetValue: '88%~92%', actualValue: '90.5%', unit: '%', isNormal: true },
      { id: 'c_02', name: '多级轻度柔碾留胚压力', targetValue: '0.12~0.15', actualValue: '0.13', unit: 'MPa', isNormal: true },
      { id: 'c_03', name: '低温抛光机控温', targetValue: '≤35', actualValue: '31.5', unit: '℃', isNormal: true },
      { id: 'c_04', name: 'AI双视高精度色选精度', targetValue: '≥99.9%', actualValue: '99.96%', unit: '%', isNormal: true },
    ],
    qualityRecord: mockQualityRecords['batch_01'],
    traceCodesGenerated: true,
    traceCodesCount: 2640,
    createdAt: '2026-08-22T08:00:00Z',
    updatedAt: '2026-08-22T17:00:00Z',
  },
  {
    id: 'batch_02',
    batchNumber: 'PROC-20260825-002',
    brandId: 'ent_01',
    brandName: '北米臻选 · 有机胚芽米',
    productSpecId: 'prod_02',
    productSpecName: '2.5kg 家庭锁鲜装 (双砖真空)',
    rawPaddyBatchNumber: 'PADDY-20260820-001',
    rawPaddyWeight: 15000,
    landId: 'land_01',
    landName: '五常核心有机基地 · 1号稻田A区',
    harvestYear: 2026,
    outputWeight: 9900,
    yieldRate: 66.0,
    processingDate: '2026-08-25T09:00:00Z',
    workshopName: '五常金穗 10万级GMP标准智能加工车间 #01产线',
    manager: '孙海峰 (加工车间主管)',
    status: 'completed',
    craftParameters: [
      { id: 'c_05', name: '佐竹胶辊砻谷脱壳率', targetValue: '88%~92%', actualValue: '91.0%', unit: '%', isNormal: true },
      { id: 'c_06', name: '多级轻度柔碾留胚压力', targetValue: '0.12~0.15', actualValue: '0.12', unit: 'MPa', isNormal: true },
    ],
    qualityRecord: mockQualityRecords['batch_02'],
    traceCodesGenerated: true,
    traceCodesCount: 3960,
    createdAt: '2026-08-25T09:00:00Z',
    updatedAt: '2026-08-25T14:20:00Z',
  },
  {
    id: 'batch_03',
    batchNumber: 'PROC-20260826-003',
    brandId: 'ent_02',
    brandName: '禾本真 · 嫩江富硒生态胚芽米',
    productSpecId: 'prod_04',
    productSpecName: '5kg 富硒生态胚芽米牛皮纸复合袋装',
    rawPaddyBatchNumber: 'PADDY-20260822-003',
    rawPaddyWeight: 13600,
    landId: 'land_03',
    landName: '嫩江平原有机基地 · 3号试验田',
    harvestYear: 2026,
    outputWeight: 9000,
    yieldRate: 66.2,
    processingDate: '2026-08-26T08:30:00Z',
    workshopName: '嫩江绿色农业加工厂 恒温柔碾车间',
    manager: '陈建华 (生产技术厂长)',
    status: 'completed',
    craftParameters: [
      { id: 'c_07', name: '低温柔碾转速', targetValue: '850~900', actualValue: '880', unit: 'rpm', isNormal: true },
    ],
    qualityRecord: mockQualityRecords['batch_03'],
    traceCodesGenerated: true,
    traceCodesCount: 1800,
    createdAt: '2026-08-26T08:30:00Z',
    updatedAt: '2026-08-26T11:00:00Z',
  },
];
